import { render, staticRenderFns } from "./BaseStarRating.vue?vue&type=template&id=7710e758"
import script from "./BaseStarRating.vue?vue&type=script&lang=js"
export * from "./BaseStarRating.vue?vue&type=script&lang=js"
import style0 from "./BaseStarRating.vue?vue&type=style&index=0&id=7710e758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports